import React, { useEffect, useState } from "react";
const Gallery = ({ announcement }) => {
  const [data, setData] = useState([]);
  const showData = () => {
    fetch("http://www.trinityhighschools.com/api/gallary.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  };
  useEffect(() => {
    showData();
  }, []);
  return (
    <>
      <div className="container">
        <div className="row gallery">
          {data.map((img, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <figure>
                <img
                  src={"assets/gallary/" + img.filename}
                  alt={`Gallery ${idx + 1}`}
                  className="gallery_img"
                />
              </figure>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-light p-3 mt-4 rounded">
        <div className="overflow-hidden whitespace-nowrap">
          <div className="animate-marquee text-primary font-bold">
            {announcement}
          </div>
        </div>
      </div>

      <style>{`
        .animate-marquee {
          display: inline-block;
          padding-left: 50%;
          animation: marquee 15s linear infinite;
        }
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </>
  );
};

export default Gallery;
